import { RobotAvatar, robotColor } from "@/entities/robot";
import type { components } from "@/api/types";
import { formatMoney, formatSlot } from "@/shared/lib";

type AccrualItem = components["schemas"]["AccrualItem"];

/**
 * Строка «последние начисления»: аватар, точка цвета, имя, время и сумма.
 *
 * Сумма всегда зелёная, а не в цвете робота: в этом блоке важно, что деньги
 * пришли, а какой именно робот их принёс — уже сказано именем слева.
 */
export function AccrualRow({ item }: { item: AccrualItem }) {
  return (
    <article
      className="grid min-h-10 grid-cols-[29px_7px_1fr_auto_auto] items-center gap-1.5 border-b border-border-hair py-1.5 last:border-b-0"
      style={{ color: robotColor(item.robot) }}
    >
      <RobotAvatar robot={item.robot} size={28} />
      <span aria-hidden="true" className="size-1.5 rounded-full bg-current shadow-[0_0_var(--glow-blur-sm)_currentColor]" />

      <span className="truncate text-small font-semibold">{item.robot.name}</span>

      <time dateTime={item.at} className="shrink-0 px-2 text-caption text-text-secondary">
        {formatSlot(item.at, { withTime: true })}
      </time>

      <span className="shrink-0 text-small font-semibold text-status-profit">
        {formatMoney(item.amount, { sign: "always", suffix: "USDT" })}
      </span>
    </article>
  );
}
